import  {createRouter, createWebHashHistory} from 'vue-router'

let routes = [{
    path: '/',
    component: () =>import ( /* webpackChunkName: "login" */ '@/views/Login')
},{
    path: '/main',
    component: () => import ( /* webpackChunkName: "main" */ '@/views/Main'),
    children: [{
            path: '',
            component: () => import ( /* webpackChunkName: "dashboard" */ '@/views/dashboard')
        },{
            path: '/sys/user',
            component: () => import ( /* webpackChunkName: "sys-user" */ '@/views/sys/user/index')
        }, {
            path: '/sys/role',
            component: () => import ( /* webpackChunkName: "sys-role" */ '@/views/sys/role/index')
        }, {
            path: '/sys/token',
            component: () => import ( /* webpackChunkName: "sys-token" */ '@/views/sys/token/index')
        },{
            path: '/sys/country/index',
            component: () => import ( /* webpackChunkName: "sys-country" */ '@/views/sys/country/index')
        },{
            path: '/sys/i18n/index',
            component: () => import ( /* webpackChunkName: "sys-i18n" */ '@/views/sys/i18n/index')
        }, {
            path: '/sys/menu',
            component: () => import ( /* webpackChunkName: "sys-menu" */ '@/views/sys/menu/index')
        },{
            path: '/sys/dict/index',
            component: () => import ( /* webpackChunkName: "sys-dict-index" */ '@/views/sys/dict/index')
        },{
            path: '/sys/dict/info',
            component: () => import ( /* webpackChunkName: "sys-dict-info" */ '@/views/sys/dict/info')
        },{
            path: '/sys/dict/update',
            component: () => import ( /* webpackChunkName: "sys-dict-update" */ '@/views/sys/dict/update')
        },{
            path: '/sys/param/index',
            component: () => import ( /* webpackChunkName: "sys-param" */ '@/views/sys/param/index')
        },{
            path: '/sys/genID/index',
            component: () => import ( /* webpackChunkName: "sys-genID" */ '@/views/sys/genID/index')
        }, {
            path: '/sys/org/index',
            component: () => import ( /* webpackChunkName: "sys-org-index" */ '@/views/sys/org/index')
        },{
            path: '/sys/org/update',
            component: () => import ( /* webpackChunkName: "sys-org-update" */ '@/views/sys/org/update')
        },{
            path: '/sys/org/info',
            component: () => import ( /* webpackChunkName: "sys-org-info" */ '@/views/sys/org/info')
        },{
            path: '/basedata/groupDoc/index',
            component: () =>import ( /* webpackChunkName: "event-groupDoc-index" */ '@/views/basedata/groupDoc/index')
        },{
            path: '/basedata/projectDoc/index',
            component: () =>import ( /* webpackChunkName: "event-projectDoc-index" */ '@/views/basedata/projectDoc/index')
        },{
            path: '/basedata/baseRound/index',
            component: () =>import ( /* webpackChunkName: "event-baseRound-index" */ '@/views/basedata/baseRound/index')
        },{
            path: '/basedata/roundDoc/index',
            component: () =>import ( /* webpackChunkName: "event-roundDoc-index" */ '@/views/basedata/roundDoc/index')
        },{
            path: '/basedata/raceDoc/index',
            component: () =>import ( /* webpackChunkName: "event-raceDoc-index" */ '@/views/basedata/raceDoc/index')
        },{
            path: '/basedata/athlete/index',
            component: () =>import ( /* webpackChunkName: "event-athlete-index" */ '@/views/basedata/athlete/index')
        },{
            path: '/basedata/customer/index',
            component: () =>import ( /* webpackChunkName: "event-customer-index" */ '@/views/basedata/customer/index')
        },{
            path: '/event/game/index',
            component: () =>import ( /* webpackChunkName: "event-game-index" */ '@/views/event/game/index')
        },{
            path: '/event/game/update',
            component: () =>import ( /* webpackChunkName: "event-game-update" */ '@/views/event/game/update')
        },{
            path: '/event/game/info',
            component: () =>import ( /* webpackChunkName: "event-game-info" */ '@/views/event/game/info')
        },{
            path: '/event/project/index',
            component: () =>import ( /* webpackChunkName: "event-project-index" */ '@/views/event/project/index')
        },{
            path: '/event/project/info',
            component: () =>import ( /* webpackChunkName: "event-project-info" */ '@/views/event/project/info')
        },{
            path: '/event/entry/index',
            component: () =>import ( /* webpackChunkName: "event-entry-index" */ '@/views/event/entry/index')
        },{
            path: '/event/entry/update',
            component: () =>import ( /* webpackChunkName: "event-entry-update" */ '@/views/event/entry/update')
        },{
            path: '/event/entry/info',
            component: () =>import ( /* webpackChunkName: "event-entry-info" */ '@/views/event/entry/info')
        },{
            path: '/event/schedule/index',
            component: () =>import ( /* webpackChunkName: "event-schedule-index" */ '@/views/event/schedule/index')
        },{
            path: '/event/round/index',
            component: () =>import ( /* webpackChunkName: "event-round-index" */ '@/views/event/round/index')
        },{
            path: '/event/drawLot/index',
            component: () =>import ( /* webpackChunkName: "event-drawLot-index" */ '@/views/event/drawLot/index')
        },{
            path: '/event/drawLot/info',
            component: () =>import ( /* webpackChunkName: "event-drawLot-info" */ '@/views/event/drawLot/info')
        },{
            path: '/event/crewNumber/index',
            component: () =>import ( /* webpackChunkName: "event-crewNumber-index" */ '@/views/event/crewNumber/index')
        },{
            path: '/event/crewNumber/info',
            component: () =>import ( /* webpackChunkName: "event-crewNumber-info" */ '@/views/event/crewNumber/info')
        },{
            path: '/event/crewNumber/update',
            component: () =>import ( /* webpackChunkName: "event-crewNumber-update" */ '@/views/event/crewNumber/update')
        },{
            path: '/event/withDrawal/index',
            component: () =>import ( /* webpackChunkName: "event-withDrawal-index" */ '@/views/event/withDrawal/index')
        },{
            path: '/event/boatLane/index',
            component: () =>import ( /* webpackChunkName: "event-boatLane-index" */ '@/views/event/boatLane/index')
        },{
            path: '/event/boatTransfer/index',
            component: () =>import ( /* webpackChunkName: "event-boatTransfer-index" */ '@/views/event/boatTransfer/index')
        },{
            path: '/event/race/index',
            component: () =>import ( /* webpackChunkName: "event-race-index" */ '@/views/event/race/index')
        },{
            path: '/event/race/info',
            component: () =>import ( /* webpackChunkName: "event-race-info" */ '@/views/event/race/info')
        },{
            path: '/event/result/index',
            component: () =>import ( /* webpackChunkName: "event-result-index" */ '@/views/event/result/index')
        },{
            path: '/event/medal/index',
            component: () =>import ( /* webpackChunkName: "event-medal-index" */ '@/views/event/medal/index')
        },{
            path: '/event/raceBoard/index',
            component: () =>import ( /* webpackChunkName: "event-raceBoard-index" */ '@/views/event/raceBoard/index')
        },{
            path: '/event/matchMap/index',
            component: () =>import ( /* webpackChunkName: "event-matchMap-index" */ '@/views/event/matchMap/index')
        },{
            path: '/event/sixteenBracket/index',
            component: () =>import ( /* webpackChunkName: "event-sixteenBracket-index" */ '@/views/event/sixteenBracket/index')
        },{
            path: '/event/starter/index',
            component: () =>import ( /* webpackChunkName: "event-starter-index" */ '@/views/event/starter/index')
        },{
            path: '/event/starter/info',
            component: () =>import ( /* webpackChunkName: "event-starter-info" */ '@/views/event/starter/info')
        }
    ]
},{
    path: '/event/raceBoard/info',
    component: () =>import ( /* webpackChunkName: "event-raceBoard-info" */ '@/views/event/raceBoard/info')
},{
    path: '/event/matchMap/info',
    component: () =>import ( /* webpackChunkName: "event-matchMap-info" */ '@/views/event/matchMap/info')
},{
    path: '/event/sixteenBracket/info',
    component: () =>import ( /* webpackChunkName: "event-sixteenBracket-info" */ '@/views/event/sixteenBracket/info')
},{
    path: '/general/docs/index',
    component: () =>import ( /* webpackChunkName: "general-docs-index" */ '@/views/general/docs/index')
},
{
    path: '/general/docs/matchMap',
    component: () =>import ( /* webpackChunkName: "general-docs-matchMap" */ '@/views/general/docs/matchMap')
}];


const router = createRouter({
    history: createWebHashHistory(),
    routes
  })
export default router;